/****************************************************
 * Module Name:  ExcelUpload.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import CommonSnackbar from "../common/commonSnackBar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { LoadingButton } from "@mui/lab";
import { BackupTable } from "@mui/icons-material";
import Constants from "../../utility/constants";
import NoPermission from "../common/noPermission";
import DnkProxy from "../../utility/proxy/worker/dnkProxy";
import Select from "react-select";
import PageTitle from "../common/pageTitle";

const DnkInvoiceUpload = () => {
    const [uploadResponse, setUploadResponse] = useState([]);
    const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [showError, setShowError] = useState(false);
    const [access, setAccess] = useState(false);
    const [fileUploadType, setFileUploadType] = useState([]);
    const [fileUploadTypeOptions, setFileUploadTypeOptions] = useState([]);

    useEffect(() => {
        PageTitle("ANALYSIS_DNKDATA_INVOICEUPLOAD");
        checkPermission();
        getAllFileUploadType();
    }, [])

    const checkPermission = () => {
        let allowed = Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.ANALYSIS_DNKDATA_INVOICEUPLOAD
        ) !== undefined
        if (!allowed) {
            setAccess(true)
            return <NoPermission />
        }
    }

    const getAllFileUploadType = () => {
        const type = Constants.DNK_UPLOAD_TYPE[0];
        setFileUploadTypeOptions(Constants.DNK_UPLOAD_TYPE)
        setFileUploadType(type);
    }

    const handleUpload = (e) => {
        let data = new FormData();
        data.append("file", e.target.files[0]);
        setUploadLoader(true);
        DnkProxy.UploadDnkExcel(fileUploadType.value, data, (response) => {
            if (response) {
                setUploadResponse(response);
                setUploadSuccessSnackbar(true);
                setUploadLoader(false);
            } else {
                setShowError(true);
                setUploadLoader(false);
            }
        });
    };

    const handleClose = () => {
        setUploadSuccessSnackbar(false);
    };

    const handleClear = () => {
        const fileInput = document.getElementById('file-input');
        fileInput.value = null;
    }

    return (
        <div>
            {uploadResponse !== "" ? (
                <CommonSnackbar
                    show={uploadSuccessSnackbar}
                    message={
                        uploadResponse.status === "SUCCESS"
                            ? `File Upload Successfully \n Changes Will Reflect Within 1 Hour`
                            : uploadResponse.errorMessage
                    }
                    variant={uploadResponse.status === "SUCCESS" ? "success" : "error"}
                    autoHide={false}
                    title={uploadResponse.status === "SUCCESS" ? "Success" : "Error"}
                    handleClose={handleClose}
                />
            ) : null}
            <CommonSnackbar
                show={showError}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setShowError(false)}
            />
            {
                access ? <NoPermission /> : (
                    <div>
                        <Container maxWidth="xxl">

                            <Box
                                sx={{ backgroundColor: '#ffrf' }}
                                display={"flex"}
                                justifyContent="center"
                                alignItems={"center"}
                                height={"80vh"}
                                gap="20px"
                                flexDirection={"column"}
                            >
                                <Box
                                    display={"flex"}
                                    justifyContent="center"
                                    alignItems={"center"}
                                    gap="20px"
                                >
                                    <Typography variant="h4">Upload DNK Data</Typography>
                                    <Box
                                        sx={{
                                            width: "200px",
                                        }}
                                    >
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            menuPortalTarget={document.body}
                                            styles={Constants.Styles}
                                            options={fileUploadTypeOptions}
                                            value={fileUploadType}
                                            isSearchable={false}
                                            onChange={(e) => setFileUploadType(e)}
                                        />
                                    </Box>
                                    <LoadingButton
                                        variant="contained"
                                        component="label"
                                        szie="large"
                                        loading={uploadLoader}
                                        loadingPosition="start"
                                        startIcon={<UploadFileIcon size="large" />}
                                        color="success"
                                    >
                                        Upload
                                        <input
                                            id="file-input"
                                            hidden
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            multiple
                                            type="file"
                                            onChange={(e) => handleUpload(e)}
                                            onClick={(e) => handleClear()}
                                        />
                                    </LoadingButton>
                                </Box>

                                {fileUploadType.value === "INVOICE" && (
                                    <Box display={'flex'}>
                                        <Typography variant="h6">Download Sample DNK Invoice Upload &#8594;</Typography>
                                        <a
                                            href="/demo_excel/SampleDNKInvoiceUpload.csv"
                                            download="SampleDNKInvoiceUpload.csv"
                                            style={{ color: "red" }}
                                        >
                                            <BackupTable size={25} />
                                        </a>
                                    </Box>)}
                            </Box>
                        </Container>
                    </div>
                )
            }
        </div>)
}

export default DnkInvoiceUpload;